import { Alert } from '@surecompanies/core_components'
import React from 'react'
import { formatDateTime } from '../utils/run-display'

interface SnapshotNoteProps {
  startedAt: string | null | undefined
}

/**
 * The report is a snapshot of the enrollments when the run executed, not live
 * data, so a fixed enrollment keeps showing until the next audit run.
 */
export default function SnapshotNote({ startedAt }: SnapshotNoteProps) {
  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message={`Data as of ${formatDateTime(
        startedAt
      )}; fixed enrollments appear until the next audit run.`}
    />
  )
}
